<form id="login" novalidate>
	<div class="p-3 bg-green color-white">
		<p class="small uc text-center mb-0">Connexion à votre compte<br/>Mares Libellules</p>
	</div>

	<div class="p-3 bb">
		<?-user.getFormError()?>

		<? var offline = !app.is('online'); ?>
		<? if( offline ) { ?>
			<div class="alert alert-warning">
				La connexion à votre compte utilisateur est impossible sans accès à Internet.
			</div>
		<? } ?>

		<div class="form-group">
			<?-user.getFormField('email','Adresse email', offline ? {type:'email', disabled:true} : {type:'email'},{class:'fw-600'})?>
		</div>

		<div class="form-group">
			<?-user.getFormField('password','Mot de passe', offline ? {type:'password', disabled:true} : {type:'password'},{class:'fw-600'})?>
		</div>

		<p class="pt-3 text-center">
			<button id="login-button" class="btn btn-lg btn-green btn-block" type="submit"<?= offline ? ' disabled' : '' ?>>Connexion</button>
		</p>

		<p class="pt-2 mb-1 small text-center">
			<a href="<?=app.config.host.root?>/mot-de-passe-oublie.html" class="color-green" target="_blank">Mot de passe oublié <i class="fa fa-external-link"></i></a>
		</p>
	</div>

	<div class="p-3">
		<p class="small text-center mb-1 uc">Pas encore de compte ?</p>
		<p class="small text-center mb-0"><a href="#user/create" class="color-green">Créez votre compte gratuitement</a></p>
	</div>
</form>
